<template>
  <div class="home">
    <!-- <Navbar /> -->
    <vue-headful title="CHECK CODE" />

    <fish-segment>
      <fish-loader :active="isLoading"></fish-loader>

      <a-row>
        <a-col :xs="0" :sm="4" :md="5" :lg="6"></a-col>

        <a-col :xs="24" :sm="16" :md="14" :lg="12">
          <fish-card fluid>
            <div slot="header">KIỂM TRA MÃ TRÚNG THƯỞNG</div>

            <a-form style="width: 100%" :form="form" @submit="handleSubmit">
              <a-form-item
                :validate-status="CodeError() ? 'error' : ''"
                :help="CodeError() || ''"
              >
                <a-input
                  autocomplete="off"
                  v-decorator="[
                    'Code',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Vui lòng nhập CODE hoặc HASHCODE!',
                        },
                      ],
                    },
                  ]"
                  placeholder="Nhập CODE hoặc SHA256 HASHCODE"
                >
                  <a-icon
                    slot="prefix"
                    type="key"
                    style="color: rgba(0, 0, 0, 0.25)"
                  />
                </a-input>
              </a-form-item>

              <a-form-item>
                <a-button
                  type="primary"
                  html-type="submit"
                  :disabled="hasErrors(form.getFieldsError())"
                >
                  <a-icon type="search" />
                  CHECK
                </a-button>
              </a-form-item>
            </a-form>
          </fish-card>
        </a-col>

        <a-col :xs="0" :sm="4" :md="5" :lg="6"></a-col>
      </a-row>

      <br />

      <fish-card v-if="HasResult" fluid color="orange">
        <div slot="header">THÔNG TIN MÃ TRÚNG THƯỞNG</div>

        <a-table
          rowKey="_id"
          size="small"
          :columns="ScratchColumns"
          :data-source="ScratchData"
          :pagination="false"
        >
          <template slot="HashCode" slot-scope="text">
            <a-tooltip :title="text">
              <span>
                {{ ShortHash(text) }}
              </span>
            </a-tooltip>
          </template>

          <template slot="IsActive" slot-scope="text">
            <a-tag :color="text ? 'red' : 'green'">
              {{ text ? "ĐÃ SỬ DỤNG" : "CHƯA SỬ DỤNG" }}
            </a-tag>
          </template>

          <template slot="Active_Time" slot-scope="text">
            <span>
              {{ FormatDateTime(text) }}
            </span>
          </template>

          <template slot="Topup_Amount" slot-scope="text">
            {{ FormatNumber(text) }}
          </template>
        </a-table>
      </fish-card>

      <br v-if="HasResult" />

      <fish-card v-if="HasResult" fluid>
        <div slot="header">LỊCH SỬ ENTRY CỦA MÃ</div>

        <a-table
          rowKey="Request_ID"
          size="small"
          :columns="EntryColumns"
          :data-source="EntryData"
          :pagination="false"
        >
          <template slot="Created_At" slot-scope="text">
            {{ FormatDateTime(text) }}
          </template>

          <template slot="Scratch_Status" slot-scope="text">
            <a-tag :color="GetScratchState(text).Color">
              {{ GetScratchState(text).Message }}
            </a-tag>
          </template>

          <template slot="Status" slot-scope="text">
            <a-tag :color="GetEntryState(text).Color">
              {{ GetEntryState(text).Message }}
            </a-tag>
          </template>

          <template slot="Topup_Amount" slot-scope="text">
            {{ FormatNumber(text) }}
          </template>

          <template slot="IsCashout" slot-scope="text">
            <a-tag :color="text ? 'green' : 'blue'">
              <a-icon :type="text ? 'dollar' : 'gift'" />
              {{ text ? "TIỀN MẶT" : "VOUCHER" }}
            </a-tag>
          </template>
        </a-table>

        <a-empty
          v-if="!EntryData.length"
          description="Chưa có Entry sử dụng mã này"
        />
      </fish-card>
    </fish-segment>
  </div>
</template>

<script>
function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

// import Navbar from "@/components/Navbar.vue";

const moment = require("moment");

export default {
  name: "CheckCode",

  components: {
    // Navbar,
  },

  mounted() {
    this.$nextTick(() => {
      this.form.validateFields();
    });
  },

  data() {
    return {
      isLoading: false,

      hasErrors,

      form: this.$form.createForm(this, {
        name: "guest_check_code",
      }),

      HasResult: false,

      ScratchData: [],

      EntryData: [],

      ScratchColumns: [
        {
          title: "HASH",
          dataIndex: "HashCode",
          key: "HashCode",
          scopedSlots: {
            customRender: "HashCode",
          },
        },
        {
          title: "TRẠNG THÁI",
          dataIndex: "IsActive",
          key: "IsActive",
          scopedSlots: {
            customRender: "IsActive",
          },
        },
        {
          title: "NGÀY KÍCH HOẠT",
          dataIndex: "Active_Time",
          key: "Active_Time",
          scopedSlots: {
            customRender: "Active_Time",
          },
        },
        {
          title: "SĐT",
          dataIndex: "User_ID",
          key: "User_ID",
        },
        {
          title: "GIÁ TRỊ",
          dataIndex: "Topup_Amount",
          key: "Topup_Amount",
          scopedSlots: {
            customRender: "Topup_Amount",
          },
        },
      ],

      EntryColumns: [
        {
          title: "#",
          dataIndex: "Index",
          key: "Index",
        },
        {
          title: "SĐT",
          dataIndex: "User_ID",
          key: "User_ID",
        },
        {
          title: "CODE",
          dataIndex: "Scratch_Code",
          key: "Scratch_Code",
        },
        {
          title: "NGÀY NHẬP",
          dataIndex: "Created_At",
          key: "Created_At",
          scopedSlots: {
            customRender: "Created_At",
          },
        },
        {
          title: "KẾT QUẢ MÃ",
          dataIndex: "Scratch_Status",
          key: "Scratch_Status",
          scopedSlots: {
            customRender: "Scratch_Status",
          },
        },
        {
          title: "GIÁ TRỊ",
          dataIndex: "Topup_Amount",
          key: "Topup_Amount",
          scopedSlots: {
            customRender: "Topup_Amount",
          },
        },
        // {
        //   title: "TRẢ THƯỞNG",
        //   dataIndex: "IsCashout",
        //   key: "IsCashout",
        //   scopedSlots: {
        //     customRender: "IsCashout",
        //   },
        // },
      ],
    };
  },

  computed: {
    oUser() {
      return this.$store.state.oUser || {};
    },
  },

  methods: {
    CodeError() {
      const { getFieldError, isFieldTouched } = this.form;

      return isFieldTouched("Code") && getFieldError("Code");
    },

    GetAPIData(Response) {
      return Response && Response.data ? Response.data : Response;
    },

    async PostAPI(Path, Data) {
      Data.Token = this.oUser.Token;
      return await this.$PostAPI(Path, Data);
    },

    ShortHash(Value) {
      const Text = String(Value || "");

      if (Text.length <= 16) {
        return Text;
      }

      return Text.substring(0, 8) + "..." + Text.substring(Text.length - 8);
    },

    FormatDateTime(Value) {
      if (!Value) {
        return "---";
      }

      const DateValue = moment(Value);

      if (!DateValue.isValid()) {
        return "---";
      }

      return DateValue.format("DD/MM/YYYY HH:mm:ss");
    },

    FormatNumber(Value) {
      return Number(Value || 0).toLocaleString("vi-VN");
    },

    GetScratchState(Value) {
      const Status = String(Value || "").toUpperCase();

      const Map = {
        SUCCESS: {
          Color: "green",
          Message: "Trúng thưởng",
        },

        WRONG: {
          Color: "orange",
          Message: "Không chính xác",
        },

        DUPLICATE: {
          Color: "blue",
          Message: "Đã sử dụng",
        },

        ENDTIME: {
          Color: "gold",
          Message: "Chương trình kết thúc",
        },

        NOTYET: {
          Color: "cyan",
          Message: "Chưa bắt đầu",
        },

        BLOCK: {
          Color: "orange",
          Message: "Tạm khóa",
        },

        BLACKLIST: {
          Color: "red",
          Message: "Blacklist",
        },
      };

      return (
        Map[Status] || {
          Color: "default",
          Message: Value || "---",
        }
      );
    },

    GetEntryState(Value) {
      const Status = String(Value || "").toUpperCase();

      const Map = {
        IN_REVIEW: {
          Color: "orange",
          Message: "Chờ kiểm duyệt",
        },

        RE_REVIEW: {
          Color: "gold",
          Message: "Kiểm duyệt lại",
        },

        PENDING: {
          Color: "cyan",
          Message: "Chờ Supervisor",
        },

        APPROVED: {
          Color: "blue",
          Message: "Đã duyệt",
        },

        GET_VOUCHER: {
          Color: "processing",
          Message: "Đang lấy voucher",
        },

        VOUCHER_ISSUED: {
          Color: "red",
          Message: "Lấy voucher lỗi",
        },

        SENT_VOUCHER: {
          Color: "blue",
          Message: "Đã lấy voucher",
        },

        SENT_ISSUED: {
          Color: "red",
          Message: "Gửi voucher lỗi",
        },

        COMPLETED: {
          Color: "green",
          Message: "Hoàn thành",
        },

        REJECTED: {
          Color: "red",
          Message: "Từ chối",
        },
      };

      return (
        Map[Status] || {
          Color: "default",
          Message: Value || "---",
        }
      );
    },

    async handleSubmit(Event) {
      Event.preventDefault();

      this.form.validateFields(async (Error, Values) => {
        if (Error) {
          return;
        }

        this.ScratchData = [];
        this.EntryData = [];
        this.HasResult = false;

        try {
          this.isLoading = true;

          const Response = await this.PostAPI("/check-code", {
            Code: Values.Code,
          });

          const Result = this.GetAPIData(Response);

          if (!Result || Result.State !== 1) {
            this.$message.error(
              Result && Result.Message
                ? Result.Message
                : "Không kiểm tra được mã.",
              3000,
            );

            return;
          }

          const Data = Result.Data || {};

          this.HasResult = true;

          this.ScratchData = Data.Scratch ? [Data.Scratch] : [];

          this.EntryData = (Data.Entries || []).map((Entry, Index) => {
            return Object.assign(
              {
                Index: Index + 1,
              },
              Entry,
            );
          });
        } catch (Error) {
          console.log("Guest-CheckCode-Error:", Error);

          this.$message.error(
            "Có lỗi xảy ra trong quá trình kiểm tra mã.",
            3000,
          );
        } finally {
          this.isLoading = false;
        }
      });
    },
  },
};
</script>
